import React from "react";

const features = [
  {
    background: "#F1F1F1",
    title: (
      <>
        Automated <br /> AI Control .
      </>
    ),
    description:
      "Let AI manage bookings and orders. Automatically sends confirmation and reminder emails.",
    icon: "/images/icon/icon_100.svg",
    width: 169,
    height: 165,
    delay: "100",
  },
  {
    background: "#d4d4d4",
    title: (
      <>
        Attract More <br /> Customers .
      </>
    ),
    description:
      "Expand your reach and gain new customers on the large retail marketplace.",
    icon: "/images/icon/icon_101.svg",
    width: 202,
    height: 170,
    delay: "200",
  },
  {
    background: "#c1c1c1",
    title: (
      <>
        Keep Digital
        <br />
        Keep Simple.
      </>
    ),
    description:
      "Digital tools for seamless operations and customer engagement.",
    icon: "/images/icon/icon_102.svg",
    width: 175,
    height: 175,
    delay: "300",
  },
];

const Feature = () => {
  return (
    <>
      {features.map((feature, index) => (
        <div
          key={index}
          className="relative p-6 rounded-xl transition-all duration-300 hover:border-2 hover:border-redlight"
          style={{ background: feature.background }}
          data-aos="fade-up"
          data-aos-delay={feature.delay}
        >
          <h4 className="text-xl font-semibold text-gray-800 mb-2">
            {feature.title}
          </h4>
          <p className="text-textGray max-w-[300px]">{feature.description}</p>
          <img
            src={feature.icon}
            alt="icon"
            className="absolute top-4 right-4 w-16 opacity-100"
          />
        </div>
      ))}
    </>
  );
};

export default Feature;
